import {createTranslate} from '@rambler-tech/translate'
import {pluralize} from '@rambler-tech/pluralize'

const validationsMessages = {
  field_empty: 'Поле должно быть заполнено',
  field_short:
    'Длина должна быть не менее (pluralize $1|символа|символов|символов)',
  field_long:
    'Длина должна быть не более (pluralize $1|символа|символов|символов)',
  field_invalid:
    'Можно использовать русские и латинские буквы, цифры, пробел и символы _ -',
  email_empty: 'Введите email',
  email_invalid: 'Недопустимый email',
  password_empty: 'Необходимо ввести пароль',
  password_invalid:
    'Пароль должен содержать от 8 до 32 символов, включать хотя бы одну заглавную латинскую букву, одну строчную и одну цифру',
  password_cyrillic_chars: 'Вы вводите русские буквы',
  password_not_supported_chars:
    'Символ "$1" не поддерживается. Можно использовать символы ! @ $ % ^ & * ( ) _ - +',
  password_confirm: 'Пароли не совпадают',
  password_match: 'Введено верно',
  birthday_empty: 'Укажите дату рождения полностью',
  birthday_invalid: 'Неверная дата',
  birthday_min:
    'Зарегистрироваться могут только пользователи, достигшие (pluralize $1|года|лет|лет)',
  gender_empty: 'Выберите пол',
  geo_empty: 'Выберите населенный пункт',
  recaptcha_empty: 'Пройдите верификацию, пожалуйста',
  captcha_empty: 'Неверные символы',
  question_empty: 'Укажите вопрос',
  question_long: 'Вопрос должен быть не более 100 символов',
  answer_empty: 'Ответ на вопрос не может быть пустым',
  answer_long: 'Ответ на вопрос должен быть не более 64 символов',
  phone_empty: 'Введите телефон',
  phone_invalid: 'Некорректный номер телефона',
  sms_code_empty: 'Введите код подтверждения',
  sms_code_not_sent: 'Код не запрошен',
  mail_not_allowed:
    'Данную почту нельзя привязать. Используйте электронную почту других сервисов.'
}

export const translate = createTranslate(validationsMessages, {pluralize})
